'use strict';

const libPictView = require('pict-view');

/**
 * Plansheet's adapter for the vendored Claude session viewer.
 *
 * The viewer (a fork of claude-session-transformer, vendored under this
 * directory) is a set of Pict views (Dropzone, Layout, Signature, Timeline,
 * Conversation, ToolDetail, AgentDetail) plus a SessionParser provider. Those
 * views reach the host application through three seams, all of which plansheet
 * provides (see Pict-Application-Plansheet.js):
 *   - PictApplication.onSessionLoaded(session) renders the viewer
 *   - PictApplication.showSessions()           returns to the session list
 *   - providers.SessionAPI.uploadSession(...)  saves a dropped zip
 *
 * Plansheet drives the viewer through this one section view, registered as
 * 'Pict-Section-ClaudeTransformer' and called in exactly two ways:
 *   - showUploader()      -> showDropzone()       (upload a new session)
 *   - openServerSession() -> loadSessionFromZip() (view a stored session)
 */
class PictViewClaudeTransformerSection extends libPictView
{
	/**
	 * Render the dropzone into #ClaudeTransformer-Workspace. When a signed-in
	 * user drops a session zip, the Dropzone uploads it to their account via
	 * SessionAPI and returns to the refreshed calendar on its own.
	 */
	showDropzone()
	{
		if (this.pict.views.Dropzone)
		{
			this.pict.views.Dropzone.render();
		}
	}

	/**
	 * Parse a downloaded session zip and render it. Called by the app's
	 * openServerSession() after it downloads the blob for a calendar click.
	 * The parser writes the normalized session to AppData.Session, which the
	 * viewer views read; onSessionLoaded() then renders them.
	 */
	loadSessionFromZip(pBuffer, fCallback)
	{
		let tmpParser = this.pict.providers.SessionParser;
		if (!tmpParser)
		{
			if (typeof fCallback === 'function')
			{
				return fCallback(new Error('Session parser is not available in this build.'));
			}
			return;
		}
		let fParsed = (pError, pSession) =>
		{
			if (pError)
			{
				if (typeof fCallback === 'function')
				{
					return fCallback(pError);
				}
				return;
			}
			this.pict.PictApplication.onSessionLoaded(pSession);
			if (typeof fCallback === 'function')
			{
				return fCallback(null);
			}
		};
		// The stored blob is either a Claude /export .zip or a raw .jsonl transcript (what a node
		// runner files for a Project-driven run). Sniff the PK zip magic and route accordingly, so
		// both shapes open in the viewer.
		let tmpBytes = (pBuffer instanceof ArrayBuffer) ? new Uint8Array(pBuffer) : (pBuffer || new Uint8Array(0));
		let tmpIsZip = (tmpBytes.length >= 2 && tmpBytes[0] === 0x50 && tmpBytes[1] === 0x4B);
		if (tmpIsZip)
		{
			return tmpParser.parseZip(pBuffer, fParsed);
		}
		let tmpText;
		try { tmpText = (typeof TextDecoder !== 'undefined') ? new TextDecoder('utf-8').decode(tmpBytes) : String.fromCharCode.apply(null, tmpBytes); }
		catch (pDecodeError) { return fParsed(pDecodeError); }
		return tmpParser.parseJSONLText(tmpText, {}, fParsed);
	}
}

module.exports = PictViewClaudeTransformerSection;
module.exports.default_configuration = { ViewIdentifier: 'Pict-Section-ClaudeTransformer' };
